// extracted by mini-css-extract-plugin
export default {"main":"swap_main__Av4GG","form":"swap_form__POiUh","button":"swap_button__p0aAu"};